/*
 * Klaviyo "Added to Cart" tracking.
 *
 * WHY: the Klaviyo onsite embed auto-tracks Active on Site / Viewed Product /
 * identify, but it does NOT emit an "Added to Cart" metric. v1 pushed that
 * event manually; without it, browse-abandonment / cart flows keyed on
 * "Added to Cart" silently stop firing. This restores that metric by listening
 * to the theme's own `product-ajax:added` DOM event (dispatched from every add
 * path: product form, cart upsell, and both bundle types) instead of patching
 * window.fetch.
 */
(function () {
  'use strict';

  // Build the Klaviyo "Added to Cart" payload from the live cart plus the
  // item(s) the add returned. Property names follow Klaviyo's documented
  // Shopify "Added to Cart" shape so their flow filters keep working. Pure —
  // no IO — so it is unit-testable in isolation.
  function buildAddToCartPayload(cart, addedItems) {
    var origin = (typeof window !== 'undefined' && window.location && window.location.origin) || '';
    var added = addedItems && addedItems.length ? addedItems : [];
    var first = added[0];

    return {
      $value: cart.total_price / 100,
      AddedItemProductName: first ? first.product_title : undefined,
      AddedItemProductID: first ? first.product_id : undefined,
      AddedItemVariantID: first ? first.variant_id : undefined,
      AddedItemSKU: first ? first.sku : undefined,
      AddedItemVariantName: first ? first.variant_title : undefined,
      AddedItemImageURL: first ? first.image : undefined,
      AddedItemPrice: first ? first.price / 100 : undefined,
      AddedItemQuantity: first ? first.quantity : undefined,
      ItemNames: (cart.items || []).map(function (item) {
        return item.product_title;
      }),
      CheckoutURL: origin + '/cart',
      Items: (cart.items || []).map(function (item) {
        return {
          ProductID: item.product_id,
          ProductName: item.product_title,
          Quantity: item.quantity,
          ItemPrice: item.price / 100,
          RowTotal: item.line_price / 100,
          SKU: item.sku,
          ProductURL: origin + item.url,
          ImageURL: item.image,
        };
      }),
    };
  }

  // `/cart/add.js` returns the added line item directly for a single add, or
  // `{ items: [...] }` when several lines are added at once (bundles). Normalize
  // both to an array. Pure.
  function extractAddedItems(detailProduct) {
    if (!detailProduct) return [];
    if (Array.isArray(detailProduct.items)) return detailProduct.items;
    return [detailProduct];
  }

  // Push to Klaviyo. `_learnq` is the classic queue that the onsite embed's
  // klaviyo.js drains; it is safe to push to before the script has loaded.
  function track(eventName, payload) {
    window._learnq = window._learnq || [];
    window._learnq.push(['track', eventName, payload]);
  }

  function onProductAdded(event) {
    var detailProduct = event && event.detail && event.detail.product;
    var addedItems = extractAddedItems(detailProduct);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        track('Added to Cart', buildAddToCartPayload(cart, addedItems));
      })
      .catch(function () {
        /* tracking must never break the add-to-cart flow */
      });
  }

  var api = {
    buildAddToCartPayload: buildAddToCartPayload,
    extractAddedItems: extractAddedItems,
    onProductAdded: onProductAdded,
  };

  // Wire the listener only in the browser; expose the API for the test harness.
  if (typeof document !== 'undefined' && document.addEventListener) {
    document.addEventListener('product-ajax:added', onProductAdded);
    window.KlaviyoEvents = api;
  }

  // CommonJS export so the pure functions can be unit-tested under Node.
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }
})();
